import React from 'react';

const StatsBand = ({ items }) => (
  <div className="cp-stats">
    {items.map((s, i) => (
      <div key={i}>
        <div className="cp-stat-num">{s.num}</div>
        <div className="cp-stat-label">{s.label}</div>
      </div>
    ))}
  </div>
);

export default StatsBand;
